// extracted by mini-css-extract-plugin
export default {"headerSolicitudes":"TablaProducto_headerSolicitudes__DhVjk","text_danger":"TablaProducto_text_danger__uCSaD","text_success":"TablaProducto_text_success__ge9xu"};